import React from "react"
import AboutCard from "../about/AboutCard"
import Hero from "./hero/Hero"
import Testimonal from "./testimonal/Testimonal"

const Home = () => {
  return (
    <>
      <Hero />
      <AboutCard />
      <Testimonal />
    </>
  )
}

export default Home
